import { useEffect, useState } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';
import styled from 'styled-components';
import { WorkflowLiveStatusBadge } from 'modules/workflows/components/HeaderBar/WorkflowTitle';
import { UserAvatar } from 'modules/workflows/components/UserAvatar';
import { pxToRem } from 'utils/convert';
import moment from 'moment';
import { Workflow } from 'modules/workflows/types';
import { getSelectedWorkflowData } from './SelectedWorkflowData.graphql';

const StyledWorkflowStatusBadge = styled(WorkflowLiveStatusBadge)`
  width: fit-content;
`;

const DetailLabel = styled.div`
  font-weight: bold;
`;

const UserData = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${pxToRem(5)};
`;

type SelectedWorkflowDataProps = {
  selectedWorkflow: Partial<Workflow>;
};

export const SELECTED_WORKFLOW_DATA_ID = 'selected-workflow-data';
export const SELECTED_WORKFLOW_USER_ID = 'selected-workflow-user';

export const SelectedWorkflowData = ({ selectedWorkflow }: SelectedWorkflowDataProps) => {
  const { id, workflowType } = selectedWorkflow;
  const [selectedDetails, setSelectedDetails] = useState<
    Partial<Workflow> & { updatedByUserId: string }
  >();

  const { refetch, isLoading } = useGraphql(getSelectedWorkflowData, {
    fetchPolicy: 'no-cache',
    variables: {
      id,
      workflowType,
    },
    onCompleted: (res) => {
      setSelectedDetails(res?.workflow);
    },
  });

  useEffect(() => {
    if (isLoading) return;
    refetch();
  }, [selectedWorkflow]);

  return (
    <>
      <div data-test={SELECTED_WORKFLOW_DATA_ID}>
        <DetailLabel>Status</DetailLabel>
        {selectedDetails?.enabled !== undefined && (
          <StyledWorkflowStatusBadge
            isWorkflowEnabled={selectedDetails?.enabled}
            workflowType={selectedDetails?.workflowType}
          />
        )}
      </div>
      <div>
        <DetailLabel>Last modified</DetailLabel>
        <UserData data-test={SELECTED_WORKFLOW_USER_ID}>
          {moment(selectedDetails?.updatedAt).format('MMM D, YYYY [at] hh:mma [by] ')}
          {selectedDetails?.updatedByUserId && (
            <UserAvatar userId={selectedDetails?.updatedByUserId} showFullNameTooltip />
          )}
        </UserData>
      </div>
    </>
  );
};
